import React, { useState, useEffect } from 'react';
import { Link ,useLocation} from 'react-router-dom';
import zxcvbn from 'zxcvbn';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { FaCheckCircle } from 'react-icons/fa';
import { RecruiterApi } from '../../../supports/recruiterApi';
import { generateRequestId } from '../../../common/common';
import {resumeUpload}from '../../../supports/resumeUpload'; 
// import { Link, useNavigate, useLocation } from 'react-router-dom';


const PasswordStrengthMeter = ({ score }) => {
  const strength = {
    0: { text: 'Very Weak', color: 'text-red-500' },
    1: { text: 'Weak', color: 'text-orange-500' },
    2: { text: 'Fair', color: 'text-yellow-500' },
    3: { text: 'Good', color: 'text-blue-500' },
    4: { text: 'Strong', color: 'text-emerald-500' },
  };

  const currentStrength = strength[score];

  return (
    <div>
      <p className={`text-xs mt-1`}>
        Password strength: <span className={currentStrength.color}>{currentStrength.text}</span>
      </p>
    </div>
  );
};

const SignUpPage = () => {
  const [formData, setFormData] = useState({ firstName: '', lastName: '',  name: '', email: '', password: '', confirmPassword: '',  });
  const [passwordScore, setPasswordScore] = useState(0);
  const [error, setError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [fieldErrors, setFieldErrors] = useState({  firstName: '', lastName: '', name: '', email: '', password: '', confirmPassword: '', });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isPasswordFocused, setIsPasswordFocused] = useState(false);
  const [isConfirmPasswordFocused, setIsConfirmPasswordFocused] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [apiError, setApiError] = useState('');
  const [apiSuccess, setApiSuccess] = useState(false);
   const [isSectorDropdownOpen, setIsSectorDropdownOpen] = useState(false);
    const location = useLocation();
      const isResumeSignup = location.pathname === "/candidate_signup";
  const [allSectors, setAllSectors] = useState([]);
      


  // Update password strength score whenever the password changes 
  useEffect(() => { 
  fetchAllSectors()
  },[]);

 useEffect(() => {
    const handleClickOutside = (event) => {
      if (isSectorDropdownOpen && !event.target.closest('.relative')) {
        setIsSectorDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isSectorDropdownOpen]);
   
      const fetchAllSectors=async()=>{
      try {
        let payload= {
          user_payload:{
              request_id: generateRequestId(),
              
          }
      }
          let response=await resumeUpload.jobSectors(payload)
          setAllSectors(response.data)
          console.log('sectors',response) 
      } catch (error) {
        console.log(error)
      }
    }
  
  useEffect(() => {
    if (formData.password) {
      const result = zxcvbn(formData.password);
      setPasswordScore(result.score);
    } else {
      setPasswordScore(0);
    }
  }, [formData.password]);

  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  };

   const validateName = (value) => {
    const nameRegex = /^[A-Za-z\s]+$/;
    return nameRegex.test(value);
  };

  const validateField = (name, value) => {
    if (!value || value.trim() === '') {
      return `${name.charAt(0).toUpperCase() + name.slice(1)} is required.`;
    }
    return '';
  };

const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (fieldErrors[name]) {
      setFieldErrors(prev => ({ ...prev, [name]: '' }));
    }

    if (name === 'email') {
      if (!value) {
        setEmailError('');
      } else if (!validateEmail(value)) {
        setEmailError('Please enter a valid email address.');
      } else {
        setEmailError('');
      }
    }

    if (name === 'firstName' || name === 'lastName') {
      if (value && !validateName(value)) {
        setFieldErrors(prev => ({ 
          ...prev, 
          [name]: 'Only letters are allowed.' 
        }));
      } else {
        setFieldErrors(prev => ({ ...prev, [name]: '' }));
      }
    }
  };

  // Modified handleSubmit to call signUp and show success/failure accordingly
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); // Clear previous errors
    setApiError('');
    setApiSuccess(false);
    setFieldErrors({ firstName: '', lastName: '', name: '', email: '', password: '', confirmPassword: '', });

    // Validate all required fields
    const newFieldErrors = {};
    let hasErrors = false;

    if (!formData.firstName.trim()) {
      newFieldErrors.firstName = 'First name is required.';
      hasErrors = true;
    } else if (!validateName(formData.firstName)) {
      newFieldErrors.firstName = 'Only letters  are allowed.';
      hasErrors = true;
    }
    else if (formData.lastName.length > 100) {
    newFieldErrors.lastName = 'Maximum 100 characters allowed.';
    hasErrors = true;
  } else if (formData.firstName.length > 100) {
    newFieldErrors.firstName = 'Maximum 100 characters allowed.';
    hasErrors = true;
  }
    if (!formData.lastName.trim()) {
      newFieldErrors.lastName = 'Last name is required.';
      hasErrors = true;
    } else if (!validateName(formData.lastName)) {
      newFieldErrors.lastName = 'Only letters  are allowed.';
      hasErrors = true;
    }

    // Check if fields are empty
    // if (!formData.name.trim()) {
    //   newFieldErrors.name = 'Name is required.';
    //   hasErrors = true;
    // }

    if (!formData.email.trim()) {
      newFieldErrors.email = 'Email is required.';
      hasErrors = true;
    } else if (!validateEmail(formData.email)) {
      newFieldErrors.email = 'Please enter a valid email address.';
      hasErrors = true;
    }

    if (!formData.password) {
      newFieldErrors.password = 'Password is required.';
      hasErrors = true;
    }

    if (!formData.confirmPassword) {
      newFieldErrors.confirmPassword = 'Please confirm your password.';
      hasErrors = true;
    }
      // Validate sector only for candidate signup

    

    if (hasErrors) {
      setFieldErrors(newFieldErrors);
      return;
    }

    // Additional validations
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    if (passwordScore < 2) { // Enforce a minimum strength
      setError('Password is too weak. Please choose a stronger one.');
      return;
    }
    console.log('Submitting form data:', formData);
    signUp()
    setIsSubmitted(true);
  };

  const signUp = async () => {
    try {
      setApiError('')
      const requestBody = {
        user_payload: {
          request_id: generateRequestId(),
        },
        first_name:formData.firstName,
        last_name:formData.lastName,
        // username: formData.name,
        email: formData.email,
        password: formData.password,
        role_id: isResumeSignup ? 1004 : 1001, 
        // sector_id: isResumeSignup ? parseInt(formData.sector) : undefined,
         is_user: isResumeSignup 
      };
      console.log('Sign up request body:', requestBody);
      const response = await RecruiterApi.registerRecruiter(requestBody);
      console.log(response)
      if(response.success){
        setApiSuccess(true);
        return response;
      }else{
        setApiError(response.message);
        setApiSuccess(false);
      }
    } catch (error) {
      console.error("Sign up failed:", error);
      setApiError(error.message);
      return { success: false, error: error?.message || 'Unknown error' };
    }
  };

  const getInputClassName = (fieldName) => {
    const baseClasses = "mt-1 block w-full px-4 py-1.5 text-sm rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-emerald-500";
    if (fieldErrors[fieldName]) {
      return `${baseClasses} border-red-500 focus:border-red-500 border`;
    }
    if (fieldName === 'email' && emailError) {
      return `${baseClasses} border-red-500 focus:border-red-500 border`;
    }
    return `${baseClasses} border border-gray-300 focus:border-emerald-500`;
  };

  const isFormComplete = Boolean(
    formData.firstName.trim() &&
    formData.lastName.trim() &&
    // formData.name.trim() &&
    formData.email.trim() &&
    formData.password &&
     formData.confirmPassword 
  ) && !emailError;

  return (
    <div className="w-full overflow-auto max-w-md lg:scale-90">
      <div className="text-center mb-4">
        <img src={require('../../../assets/RecruiterLogo.png')} alt="MPH" className="w-[130px] mx-auto mb-4" />
      </div>
      {isSubmitted && apiSuccess ? (
        <>
         <div className="text-center bg-emerald-50 p-3">
  <div className="font-semibold p-4 rounded-md flex flex-col items-center justify-center gap-1">
    <FaCheckCircle className="text-emerald-500 text-xl" />
    <p className="text-lg">Registration Successful!</p>
    <p className="text-sm text-gray-600">
      Please check your email for confirmation.
    </p>
  </div>
</div>
        </>
      ) : (
        <>
          <h2 className="text-lg font-bold text-gray-800">Create your account</h2>
          <form onSubmit={handleSubmit} className="text-left space-y-2">
             <div className="grid grid-cols-2 gap-3">
              <div>
                <label htmlFor="firstName" className="block text-sm font-bold text-gray-700">First Name</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  autoComplete='off'
                  placeholder="First name"
                  className={getInputClassName('firstName')}
                  required
                  aria-invalid={fieldErrors.firstName ? 'true' : 'false'}
                  aria-describedby={fieldErrors.firstName ? 'firstName-error' : undefined}
                />
                {fieldErrors.firstName && (
                  <p id="firstName-error" className="mt-1 text-xs text-red-600">{fieldErrors.firstName}</p>
                )}
              </div>

              <div>
                <label htmlFor="lastName" className="block text-sm font-bold text-gray-700">Last Name</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  autoComplete='off'
                  placeholder="Last name"
                  className={getInputClassName('lastName')}
                  required
                  aria-invalid={fieldErrors.lastName ? 'true' : 'false'}
                  aria-describedby={fieldErrors.lastName ? 'lastName-error' : undefined}
                />
                {fieldErrors.lastName && (
                  <p id="lastName-error" className="mt-1 text-xs text-red-600">{fieldErrors.lastName}</p>
                )}
              </div>
            </div>
            {/* <div>
              <label htmlFor="name" className="block text-sm font-bold text-gray-700">Username</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                autoComplete='off'
                placeholder="Enter your full name"
                className={getInputClassName('name')}
                required
                aria-invalid={fieldErrors.name ? 'true' : 'false'}
                aria-describedby={fieldErrors.name ? 'name-error' : undefined}
              />
              {fieldErrors.name && (
                <p id="name-error" className="mt-1 text-xs text-red-600">{fieldErrors.name}</p>
              )}
            </div> */}

            <div>
              <label htmlFor="email" className="block text-sm font-bold text-gray-700">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="you@example.com"
                autoComplete='off'
                className={getInputClassName('email')}
                required
                aria-invalid={(fieldErrors.email || emailError) ? 'true' : 'false'}
                aria-describedby={(fieldErrors.email || emailError) ? 'email-error' : undefined}
              />
              {(fieldErrors.email || emailError) && (
                <p id="email-error" className="mt-1 text-xs text-red-600">{fieldErrors.email || emailError}</p>
              )}
            </div>
              {/* {isResumeSignup && (
              <div>
                <label htmlFor="sector" className="block text-sm font-bold text-gray-700">Sector</label>
                <div className="relative">
                  <button
                    type="button"
                    onClick={() => setIsSectorDropdownOpen(!isSectorDropdownOpen)}
                    className={`${getInputClassName('sector')} w-full text-left  cursor-pointer flex items-center justify-between ${!formData.sector ? 'text-gray-400' : 'text-gray-900'}`}
                    aria-haspopup="listbox"
                    aria-expanded={isSectorDropdownOpen}
                  >
                    <span className="block truncate">
                      {formData.sector ? allSectors.find(s => s.id === parseInt(formData.sector))?.name : 'Select a sector'}
                    </span>
                    <svg 
                      className={`h-4 w-4 text-gray-400 transition-transform duration-200 ${isSectorDropdownOpen ? 'transform rotate-180' : ''}`} 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  
                  {isSectorDropdownOpen && (
                    <div className="absolute z-20 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-[12rem] overflow-auto">
                      {allSectors.map((sector) => (
                        <div
                          key={sector.id}
                          onClick={() => {
                            setFormData({ ...formData, sector: sector.id.toString() });
                            setIsSectorDropdownOpen(false);
                            if (fieldErrors.sector) {
                              setFieldErrors(prev => ({ ...prev, sector: '' }));
                            }
                          }}
                          className={`px-4 py-2 cursor-pointer hover:bg-emerald-50 text-sm ${
                            formData.sector === sector.id.toString() ? 'bg-emerald-100 text-emerald-900' : 'text-gray-900'
                          }`}
                        >
                          {sector.name}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {fieldErrors.sector && (
                  <p id="sector-error" className="mt-1 text-xs text-red-600">{fieldErrors.sector}</p>
                )}
              </div>
            )} */}


            <div>
              <label htmlFor="password" className="block text-sm font-bold text-gray-700">Password</label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  onFocus={() => setIsPasswordFocused(true)}
                  onBlur={() => setIsPasswordFocused(false)}
                  autoComplete='off'
                  placeholder="Choose a strong password"
                  className={`${getInputClassName('password')} pr-10`}
                  required
                  aria-invalid={fieldErrors.password ? 'true' : 'false'}
                  aria-describedby={fieldErrors.password ? 'password-error' : undefined}
                />
                {(formData.password || isPasswordFocused) && (
                  <button
                    type="button"
                    onClick={() => setShowPassword((v) => !v)}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 z-10"
                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                  >
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </button>
                )}
              </div>
              {fieldErrors.password && (
                <p id="password-error" className="mt-1 text-xs text-red-600">{fieldErrors.password}</p>
              )}
              {formData.password && !fieldErrors.password && <PasswordStrengthMeter score={passwordScore} />}
            </div>

            <div>
              <label htmlFor="confirmPassword" className="block text-sm font-bold text-gray-700">Confirm Password</label>
              <div className="relative">
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  id="confirmPassword"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  onFocus={() => setIsConfirmPasswordFocused(true)}
                  onBlur={() => setIsConfirmPasswordFocused(false)}
                  autoComplete='off'
                  placeholder="Confirm your password"
                  className={`${getInputClassName('confirmPassword')} pr-10`}
                  required
                  aria-invalid={fieldErrors.confirmPassword ? 'true' : 'false'}
                  aria-describedby={fieldErrors.confirmPassword ? 'confirm-password-error' : undefined}
                />
                {(formData.confirmPassword || isConfirmPasswordFocused) && (
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword((v) => !v)}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 z-10"
                    aria-label={showConfirmPassword ? 'Hide confirm password' : 'Show confirm password'}
                  >
                    {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
                  </button>
                )}
              </div>
              {fieldErrors.confirmPassword && (
                <p id="confirm-password-error" className="mt-1 text-xs text-red-600">{fieldErrors.confirmPassword}</p>
              )}
            </div>

            {error && <p className="text-sm text-red-600">{error}</p>}
            {apiError && <p className="text-sm text-red-600">{apiError}</p>}
            <button
              type="submit"
              disabled={!isFormComplete}
              className={`mt-2 w-full flex justify-center py-1.5 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${!isFormComplete ? 'bg-gray-300 cursor-not-allowed' : 'bg-emerald-500 hover:bg-emerald-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500'}`}
            >
              Register
            </button>
          </form>

          <p className="mt-4 text-center text-sm text-gray-500">
            Already have an account?{' '}
            <Link  to={isResumeSignup ? "/resume-login" : "/login"} className="font-medium mph-primary hover:text-emerald-900">
              Sign In
            </Link>
          </p>
        </>
      )}
    </div>
  );
};

export default SignUpPage;